const mergeLocalizedContent = (base, override) => {
  if (!override) return base;
  if (Array.isArray(override)) return override;
  if (!base || typeof base !== 'object' || Array.isArray(base)) return override;

  const output = { ...base };
  Object.entries(override).forEach(([key, value]) => {
    if (value && typeof value === 'object' && !Array.isArray(value) && output[key] && typeof output[key] === 'object' && !Array.isArray(output[key])) {
      output[key] = mergeLocalizedContent(output[key], value);
      return;
    }
    output[key] = value;
  });
  return output;
};

export default mergeLocalizedContent;
